const benefits = [
  {
    icon: 'ri-search-eye-line',
    title: 'Szybsze znajdowanie produktów',
    desc: 'Znajdź setki sprawdzonych ofert w kilka minut, zamiast spędzać godziny na ręcznym przeszukiwaniu chińskich platform.',
  },
  {
    icon: 'ri-scales-3-line',
    title: 'Porównanie wielu ofert',
    desc: 'Porównuj ceny, jakość i opinie różnych sprzedawców w jednym miejscu, bez przełączania się między dziesiątkami kart.',
  },
  {
    icon: 'ri-stack-line',
    title: 'Kategorie produktów',
    desc: 'Przeglądaj produkty podzielone na czytelne kategorie – od sneakersów przez odzież streetwear po akcesoria i elektronikę.',
  },
  {
    icon: 'ri-camera-lens-line',
    title: 'Zdjęcia QC',
    desc: 'Zobacz rzeczywiste zdjęcia jakości produktów wykonane przez społeczność, zanim zdecydujesz się na zakup.',
  },
  {
    icon: 'ri-book-open-line',
    title: 'Poradniki zakupowe',
    desc: 'Korzystaj ze szczegółowych poradników dotyczących bezpiecznych zakupów, wysyłki do Polski i unikania oszustw.',
  },
  {
    icon: 'ri-group-line',
    title: 'Społeczność kupujących',
    desc: 'Dołącz do społeczności doświadczonych kupujących, którzy dzielą się opiniami, recenzjami i najlepszymi znaleziskami.',
  },
];

export default function WhyUseSection() {
  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 bg-accent-100 text-accent-700 text-xs font-medium rounded-full mb-4">
            Korzyści
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-4">
            Dlaczego warto korzystać z Kakobuy Spreadsheet?
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-2xl mx-auto">
            Tysiące polskich kupujących zaufało już Kakobuy Spreadsheet. Oto dlaczego to narzędzie zmienia sposób robienia zakupów z Chin.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {benefits.map((item, i) => (
            <div
              key={i}
              className="group p-6 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all cursor-default"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 mb-4 group-hover:bg-primary-500 group-hover:text-white transition-all">
                <i className={`${item.icon} text-xl`}></i>
              </div>
              <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2">{item.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}